import styled, { css } from "styled-components"

import Link from "~/components/atoms/Link"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Label from "~/components/atoms/Tag"
import Typography from "~/components/atoms/Typography"
import { RecruitmentStatus, RecruitmentType } from "~/consts"
import { Color, IsMobile, IsPC, LineHeight, RadiusSize, SpacingSize, TextSize } from "~/consts/style-mixins"
import { Event } from "~/entities/Event"
import { Magazine } from "~/entities/Magazine"
import { NewGradJob } from "~/entities/NewGradJob"
import { ShortInternship } from "~/entities/ShortInternship"
import { internalLink } from "~/services/helper"

import User from "./User"

interface Props {
  category: keyof typeof RecruitmentType
  recruitment: NewGradJob | ShortInternship | Event | Magazine
  className?: string
}

interface StyledProps {
  bgSrc: string
}

const RecruitmentHead = ({ category, recruitment, className }: Props) => {
  return (
    <div className={className}>
      <StyledCoverImageWrapper>
        {recruitment.thumbnailImgUrl && <StyledCoverImage bgSrc={recruitment.thumbnailImgUrl} />}
        {recruitment.status === RecruitmentStatus.private && (
          <StyledLabel size="Medium" color={Color.Attention}>
            募集終了
          </StyledLabel>
        )}
      </StyledCoverImageWrapper>
      <div>
        <StyledCategory>{RecruitmentType[category]}</StyledCategory>
        {(category === "newGradJob" || category === "shortInternship") && (
          // OPTIMIZE: instance ofで判定すると、フロントエンドに表示されなくなるので仕方なく
          // @ts-expect-error
          <StyledJobType>{recruitment.jobType}</StyledJobType>
        )}
        <Pc>
          <StyledTitle type="SubHero" lineHeightProp={160}>
            {recruitment.title}
          </StyledTitle>
        </Pc>
        <Sp>
          <StyledTitle type="SubHero" lineHeightProp={160}>
            {recruitment.title}
          </StyledTitle>
        </Sp>
        <Link href={internalLink(`/companies/${recruitment.company.id}`)}>
          <User
            type="Medium"
            iconPath={recruitment.company.logoImgUrl}
            name={recruitment.company.name}
            description={recruitment.company.overview}
          />
        </Link>
      </div>
    </div>
  )
}

const StyledCoverImageWrapper = styled.div`
  position: relative;
`

const StyledCoverImage = styled.div`
  width: 100%;
  margin-bottom: ${SpacingSize.M}px;
  padding-top: 50%;
  border-radius: ${RadiusSize.Medium}px;
  background-size: cover;
  background-position: center center;
  ${({ bgSrc }: StyledProps) => css`
    background-image: url("${bgSrc}");
  `}
`

const StyledLabel = styled(Label)`
  width: 80px;
  position: absolute;
  ${IsPC(css`
    bottom: 16px;
    left: 16px;
  `)}
  ${IsMobile(css`
    bottom: 8px;
    left: 8px;
  `)}
`

const StyledCategory = styled.span`
  font-size: ${TextSize.M}px;
  line-height: ${LineHeight.S}%;
  font-weight: bold;
  color: ${Color.Primary};
`

const StyledJobType = styled.span`
  font-size: ${TextSize.M}px;
  line-height: ${LineHeight.S}%;
  margin-left: 6px;
  font-weight: bold;
  color: ${Color.LightGray};
`

const StyledTitle = styled(Typography)`
  margin: ${SpacingSize["3XS"]}px 0 ${SpacingSize.S}px;
`

export default RecruitmentHead
